import { Panel as RSuitePanel } from 'rsuite';
import styled from 'styled-components';
import { StyledPanelProps } from './types';

export const Panel = styled(RSuitePanel)<StyledPanelProps>`
  .collapse {
    visibility: ${(props) => (props.expanded ? 'visible' : 'collapse')};
  }
`;
